import { Box } from "@prismicio/editor-ui"
import { type PropsWithChildren, type ReactNode } from "react"

import { useContentOffset } from "../app/layout/useOffset"
import { routeAnimationDuration } from "../app/routing"
import {
  mainContentMaxWidth,
  sidePanelPadding as getSidePanelPadding,
  sidePanelWidth,
} from "../document/documentLayout"

interface DocumentListLayoutProps {
  header: ReactNode
  body: ReactNode
  sidePanel: ReactNode
}

export function DocumentListLayout(props: DocumentListLayoutProps) {
  const { header, body, sidePanel } = props
  const { contentOffset } = useContentOffset()

  return (
    <Box
      display="grid"
      width="100vw"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
      height={`calc(100vh - ${contentOffset}px)`}
    >
      <Box justifyContent="center">
        <Box
          position="relative"
          top={contentOffset}
          maxWidth={mainContentMaxWidth}
          width="100%"
        >
          <SidePanel>{sidePanel}</SidePanel>
          {body}
        </Box>
      </Box>
      {header}
    </Box>
  )
}

export function SidePanel(props: PropsWithChildren) {
  const { children } = props
  const { contentOffset } = useContentOffset()

  return (
    <Box
      as="nav"
      gap={16}
      width={sidePanelWidth}
      flexShrink={0}
      maxHeight={`calc(100vh - ${contentOffset}px)`}
      flexDirection="column"
    >
      {children}
    </Box>
  )
}

// Assign padding to accommodate internal content scrollbar
export const sidePanelPadding = getSidePanelPadding("left")
